// src/layouts/MainLayout.js
import React from 'react';
import Navbar from '../components/navigation/Navbar';
import Footer from '../components/navigation/Footer';

const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow relative">
        {children}
      </main>
      {/* Stopka z własnym tłem */}
      <div className="relative z-50">
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;